
import { Grid } from "@mui/material";
import KnockOutRound from "./KnockOutRound";
import { useSelector } from "react-redux";
import { selectWorldCupResult } from "./WorldCupResultSlice";

export default function KnockOutStage() {
    const result = useSelector(selectWorldCupResult);
    return <Grid container spacing={2}>
        {result.year >= 2026 && <Grid item xs={12}>
            <KnockOutRound stage="R32" heading="Round of 32" />
        </Grid>}
        <Grid item xs={12}>
            <KnockOutRound stage="R16" heading="Round of 16" />
        </Grid>
        <Grid item xs={12}>
            <KnockOutRound stage="QF" heading="Quarter-finals" />
        </Grid>
        <Grid item xs={12} lg={6}>
            <KnockOutRound stage="SF" heading="Semi-finals" />
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
            <KnockOutRound stage="3" heading="Third place play-off" />
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
            <KnockOutRound stage="F" heading="Final" />
        </Grid>
    </Grid >;
}